import dayjs from 'dayjs'

function EventCard({ event }) {
  const start_date = dayjs(event.start_date).format('DD-MMMM-YYYY')
  const end_date = dayjs(event.end_date).format('DD-MMMM-YYYY')
  return (
    <div>
      <div
        className="group p-4 transition-transform duration-300 hover:scale-[1.01]"
        role="dialog"
        aria-modal="true"
        aria-labelledby="modalTitle"
        key={event.id}
      >
        <div className="w-full max-w-md rounded-lg p-6 shadow-lg hover:shadow-xl transition-shadow duration-300 bg-[#0166b1]">
          <div className="flex items-start justify-between">
            <h2
              id="modalTitle"
              className="text-xl font-bold sm:text-2xl text-white"
            >
              {event.name}
            </h2>

            <button
              type="button"
              className="-me-4 -mt-4 rounded-full p-2 transition-colors focus:outline-none text-gray-500 hover:bg-gray-800 hover:text-gray-300"
              aria-label="Close"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="size-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M6 18L18 6M6 6l12 12"
                ></path>
              </svg>
            </button>
          </div>

          <div className="mt-4">
            <p className="text-pretty text-gray-200">
              Start Date: {start_date} - End Date: {end_date}
            </p>
            <p className="text-pretty text-gray-200">
              {event.theme}
            </p>
            <p className="text-pretty text-gray-200">
              {event.venue}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EventCard;
